export const SET_FIELD_ERROR = 'SET_FIELD_ERROR';
export const SET_ERROR_FIELDS = 'SET_ERROR_FIELDS';
export const CLEAR_ENTITY_ERRORS = 'CLEAR_ENTITY_ERRORS';
export const CLEAR_CATEGORY_ERRORS = 'CLEAR_CATEGORY_ERRORS';
export const SET_RECOMMENDED_FIELDS = 'SET_RECOMMENDED_FIELDS';
export const CLEAR_FIELD_ERROR = 'CLEAR_FIELD_ERROR';
export const CLEAR_RECOMMENDED_FIELDS = 'CLEAR_RECOMMENDED_FIELDS';
export const SET_ERROR_FIELDS_BY_CATEGORY = 'SET_ERROR_FIELDS_BY_CATEGORY';
